import { z } from "zod"

export const fspIdSchema = z.union([z.literal("maul"), z.literal("tiffin")])

export const statusSchema = z.union([z.literal("active"), z.literal("inactive")])

export const mealTimeSchema = z.union([z.literal("Lunch"), z.literal("Dinner")])

// Temperature options for courses
export const TEMPERATURE_OPTIONS = ["COLD", "HOT"] as const
export type TTemperature = (typeof TEMPERATURE_OPTIONS)[number]
export const temperatureSchema = z.enum(TEMPERATURE_OPTIONS)

export const weekdayNumberStrSchema = z.union([
  z.literal("1"),
  z.literal("2"),
  z.literal("3"),
  z.literal("4"),
  z.literal("5"),
  z.literal("6"),
  z.literal("7"),
])

// Note that we have both a dish diet and a user diet and they are different.
export const DISH_DIET_OPTIONS = [
  "omnivore",
  "pescatarian",
  "vegan",
  "vegetarian",
  "low-carb",
  "gluten-free",
] as const

export const dishDietSchema = z.enum(DISH_DIET_OPTIONS)
export type TDishDiet = (typeof DISH_DIET_OPTIONS)[number]

export const textByLangSchema = z.object({
  en: z.string(),
  is: z.string().optional(),
  da: z.string().optional(),
})

// The list of allergens comes from Mast (mast.it)
// See the list on page 3 of this Mast PDF
// https://www.mast.is/static/files/library/Lei%C3%B0beiningar/LeidbeiningarOfnaemiothol022015JS.pdf
// TODO We are missing the 'sulfur dioxide and sulfites' option from the official list, why is that?
// If you'd like to see how restaurants actually use this information here is a google sheet
// they fill out with allergen information for their dishes
// https://docs.google.com/spreadsheets/d/1soOV7Ccei61_xZuaXHnLn91sAHKkSUFVff8cjEZN4_A/edit#gid=0
export const ALLERGEN_OPTIONS = [
  "celery",
  "crustaceans",
  "eggs",
  "fish",
  "gluten",
  "lactose",
  "lupin",
  "molluscs",
  "mustard",
  "nuts",
  "peanuts",
  "sesame",
  "sulfites",
  "soy",
] as const

export type TAllergen = (typeof ALLERGEN_OPTIONS)[number]

export const allergenSchema = z.enum(ALLERGEN_OPTIONS)

// Is nullable because Tiffin restaurants do not have this set in all cases
const pickupTimesMapSchema = z.object({
  Weekdays: z.string().nullable(),
  Weekends: z.string().nullable(),
})
export const pickupTimesByMealTimeSchema = z.object({
  Lunch: pickupTimesMapSchema,
  Dinner: pickupTimesMapSchema,
})
